import elevations from '../elevations';

import {
  primaryButtonBis,
  PrimaryButtonTheme,
  secondaryButtonBis,
  SecondaryButtonTheme,
} from './buttonTheme';
import { bisColorsTheme, ColorsTheme } from './colors';
import { bisComponentsTheme, ComponentsTheme } from './components';
import { bisFontsTheme, FontsTheme } from './fonts';
import { bisRadiuses, RadiusesTheme } from './radiuses';

interface ThemeElevations {
  abnDropDown: string;
  abnElevationWell: string;
  abnElevationTile: string;
  abnElevationProduct: string;
  abnElevationDropdown: string;
  abnElevationCard: string;
  abnElevationNewCard: string;
  abnElevationModal: string;
  abnPopover: string;
  elevationTextBoxFadeBottom: string;
  elevationTextBoxFadeTop: string;
}

export enum ThemeName {
  BIS = 'theme-bis',
}

export interface Theme
  extends FontsTheme,
    ComponentsTheme,
    ColorsTheme,
    PrimaryButtonTheme,
    SecondaryButtonTheme,
    RadiusesTheme {
  name: ThemeName;
  elevations: ThemeElevations;
}

export const bisTheme: Theme = {
  name: ThemeName.BIS,
  ...bisFontsTheme,
  ...bisComponentsTheme,
  ...bisColorsTheme,
  ...primaryButtonBis,
  ...secondaryButtonBis,
  elevations,
  ...bisRadiuses,
};
